export default class PdfNull {
  toString(): string {
    return 'null';
  }
}
